module.exports = __webpack_public_path__ + "img/especialista11.dff6d884.png";